import { useDeleteOutOfOfficeAppointmentMutation } from "../../../../../../../api/appointments/useDeleteOutOfOfficeAppointmentMutation";
import { uiNotification } from "../../../../../../../services/UINotificationService";
import { useContext } from "../context";

export function useDelete() {
  const { appointment } = useContext();

  const { mutateAsync, isLoading } = useDeleteOutOfOfficeAppointmentMutation({
    onError: () => {
      uiNotification.error(
        "Unable to delete out of office appointment. Try again later.",
      );
    },
    onSuccess: () => {
      uiNotification.success("Out of office appointment deleted successfully.");
    },
  });

  const initiate = ({ deleteAll }) => {
    return mutateAsync({
      appointmentId: appointment.id,
      allSubsequent: deleteAll,
    });
  };

  return {
    initiate,
    isLoading,
  };
}
